
import { createContext, useReducer } from "react";
import EnvoieReducer from "./EnvoieReducer";

const INITIAL_STATE = {
    envois: [],
    envoisPickupArrived: [],
    count: 1,
    isFetching: false,
    error: false,
    envoie: {},
    isFetchingAdd: false,
    errorAdd: false,
    envoieUpdate: {},
    isFetchingUpdate: false,
    errorUpdate: false,
    isFetchingGet: false,
    errorGet: false,
    costs: [],
    costsentreprise : [],
    isFetchingCosts: false,
    errorCosts: false,
    cost: "",
    isFetchingSimulate: false,
    errorSimulate: false,
    histories: [],
    isFetchingHistories: false,
    errorHistories: false,
    mess: '',
    isFetchingCostsUpdate: false,
    errorCostsUpdate: false,
};


export const EnvoieContext = createContext(INITIAL_STATE);

export const EnvoieContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(EnvoieReducer, INITIAL_STATE);
    
    return (
      <EnvoieContext.Provider
        value={{
          envois: state.envois,
          envoisPickupArrived: state.envoisPickupArrived,
          count: state.count,
          isFetching: state.isFetching,
          error: state.error,
          envoie: state.envoie,
          isFetchingAdd: state.isFetchingAdd,
          errorAdd: state.errorAdd,
          envoieUpdate: state.envoieUpdate,
          isFetchingUpdate: state.isFetchingUpdate,
          errorUpdate: state.errorUpdate,
          isFetchingGet: state.isFetchingGet,
          errorGet: state.errorGet,
          costs: state.costs,
          costsentreprise: state.costsentreprise,
          isFetchingCosts: state.isFetchingCosts,
          errorCosts: state.errorCosts,
          cost: state.cost,
          isFetchingSimulate: state.isFetchingSimulate,
          errorSimulate: state.errorSimulate,
          histories: state.histories,
          isFetchingHistories: state.isFetchingHistories,
          errorHistories: state.errorHistories,
          mess: state.mess,
          isFetchingCostsUpdate: state.isFetchingCostsUpdate,
          errorCostsUpdate: state.errorCostsUpdate,
          dispatch,
        }}
      >
        {children}
      </EnvoieContext.Provider>
    );
  };